const debugFlag = process.env.REACT_APP_DEBUG_UI;

export const isDebugUIEnabled = debugFlag !== undefined
  ? debugFlag === 'true'
  : process.env.NODE_ENV !== 'production';

